/** CoStar.Api.AnalyticReports.RentComparable.RentComparableUnitMixType */
export var RentComparableUnitMixType;
(function (RentComparableUnitMixType) {
    RentComparableUnitMixType[RentComparableUnitMixType["CompsByUnits"] = 0] = "CompsByUnits";
    RentComparableUnitMixType[RentComparableUnitMixType["CompsByBeds"] = 1] = "CompsByBeds";
})(RentComparableUnitMixType || (RentComparableUnitMixType = {}));
